<template>
    <div class="report_item export-card">
        <div :id="`person_${item.id}`" class="report_item_top">
            <div class="report_imageblock">
                <template v-for="(images_card, fi) in (item.faces || [])">
                    <img
                        v-if="faceImageSrc(images_card)"
                        :key="'face_' + fi"
                        class="report_imageblock__item"
                        :src="faceImageSrc(images_card)"
                        alt=""
                    />
                </template>
            </div>
            <div class="report_center">
                <div class="report_center__title">
                    <h5 class="report_item_top__title">
                        {{item.first_name}}
                        {{item.last_name ? item.last_name : ''}}
                    </h5>
                </div>
                <div class="report_center__data">
                    <div>
                        <div class="report_t_d">
                            <span>Detected</span>
                            <div class="report_t_d__value">
                                {{item.histories ? item.histories.length : 0}}
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Person ID</span>
                            <div class="report_t_d__value">
                                {{ item.uuid || item.person_uuid || item.id }}
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Description</span>
                            <div class="report_t_d__value">
                                {{item.info}}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="report_t_d">
                            <span>Category ID</span>
                            <div class="report_t_d__value" v-for="cat in uniqueCategories" :key="'cid_' + cat.id">
                                {{cat.id}},
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Category</span>
                            <div class="report_t_d__value" v-for="cat in uniqueCategories" :key="'cname_' + cat.id">
                                {{cat.name}},
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="report_t_d">
                            <span>Video ID</span>
                            <div class="report_t_d__value" v-for="video in (videos || [])" :key="'vid_' + video.id">
                                {{video.id}},
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Video title</span>
                            <div class="report_t_d__value" v-for="video in (videos || [])" :key="'vname_' + video.id">
                                {{video.name}},
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-show="hide_down_block && hasDetections"
            class="report_item_bottom"
        >
            <div v-for="video in (videos || [])" :key="'vblock_' + video.id" class="report_item_bottom__video">
                <h6 class="report_item_bottom__video_title">{{video.name}} ID {{video.id}}</h6>
                <div class="report_item_bottom__video_galleryblock">
                    <div
                        v-for="history in fhistories"
                        v-show="Number(history.video_id) === Number(video.id)"
                        :id="`history_${history.id}`"
                        :key="'hist_' + history.id"
                        class="report_item_bottom__video_gallery"
                    >
                        <img v-if="historyImageSrc(history)" :src="historyImageSrc(history)" alt="">
                        <div class="report_t_d">
                            <span>Global:</span>
                            <div class="report_t_d__value">
                                {{history.recognized_at}}
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Video:</span>
                            <div class="report_t_d__value">
                                {{video.date ? convertUnixTime(video.date) : "Without date" }}
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Time from begin:</span>
                            <div class="report_t_d__value">
                                {{history.rb_time}}
                            </div>
                        </div>
                        <div
                            v-if="isSpoofSuspicion(history.spoofing_atack)"
                            class="report_t_d spoof-warning"
                        >
                            <span>Подозрение на спуф</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'item',
        'videos'
    ],
    data(){
        return{
            videosids: [],
            videostitle: [],
            // Export cards always include detections (unlike interactive ReportCardList)
            hide_down_block: true
        }
    },
    methods: {
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        },
        isSpoofSuspicion(flag){
            if (flag === true || flag === 1 || flag === '1') return true;
            if (Array.isArray(flag)) {
                return flag.some(function (x) {
                    return x === true || x === 1 || x === '1';
                });
            }
            return false;
        },
        mediaUrl(image){
            if (!image) return '';
            if (image.fullpath) return image.fullpath;
            const p = image.path || '';
            if (!p) return '';
            if (p.startsWith('data:') || p.startsWith('http') || p.startsWith('/')) return p;
            if (p.startsWith('../')) return '/' + p.replace(/^\.\.\//, '');
            return `/images/${p}`;
        },
        faceImageSrc(face){
            return this.mediaUrl(face && face.image);
        },
        historyImageSrc(history){
            if (history && history.image) {
                const u = this.mediaUrl(history.image);
                if (u) return u;
            }
            const faces = (this.item && this.item.faces) || [];
            if (faces.length) return this.mediaUrl(faces[0].image);
            return '';
        },
        convertUnixTime(unix_timestamp){
            let hDate = new Date(unix_timestamp*1000),
                Y = hDate.getUTCFullYear(),
                month = hDate.getUTCMonth()+1,
                d = hDate.getUTCDate(),
                h = hDate.getUTCHours(),
                minutes = hDate.getUTCMinutes(),
                s = hDate.getUTCSeconds();
            if( month < 10) month = '0' + month;
            if( d < 10) d = '0' + d;
            if( h < 10) h = '0' + h;
            if( minutes < 10) minutes = '0' + minutes;
            if( s < 10) s = '0' + s;
            let fDate = `${Y}-${month}-${d} ${h}:${minutes}:${s}`;
            return fDate;
        },
        formatTimeFromBegin(history, videos) {
            let sec = Number(history.start_current_dt);
            if (!Number.isFinite(sec) || sec < 0) sec = 0;
            const vid = (videos || []).find(v => Number(v.id) === Number(history.video_id));
            const vBegin = vid ? Number(vid.start_time || vid.date || 0) : 0;
            if (sec > 1e9 && vBegin > 0) {
                sec = Math.max(0, sec - vBegin);
            }
            sec = Math.floor(sec);
            const h = Math.floor(sec / 3600);
            const m = Math.floor((sec % 3600) / 60);
            const s = sec % 60;
            const pad = n => (n < 10 ? '0' : '') + n;
            return `${pad(h)}:${pad(m)}:${pad(s)}`;
        },
    },
    mounted(){
        // No hash-based expand for export cards; detections always visible
    },
    computed: {
        uniqueCategories(){
            const cats = (this.item && this.item.categories) || [];
            const seen = {};
            const out = [];
            cats.forEach(cat => {
                const id = cat && cat.id != null ? Number(cat.id) : null;
                if (id == null || !Number.isFinite(id) || seen[id]) return;
                seen[id] = true;
                out.push(cat);
            });
            return out;
        },
        hasDetections(){
            return (this.videos || []).length > 0 && (this.item.histories || []).length > 0;
        },
        fhistories(){
            let fhistories = (this.item.histories || []).map(history => {
                history.rb_time = this.formatTimeFromBegin(history, this.videos);
                return history;
            });
            return fhistories;
        },
    }
}
</script>

<style lang="scss" scoped>
/* Export-only component: printable light theme (html2pdf / white page).
   Do NOT reuse interactive dark-theme colors — black text on dark bottoms
   (or white text on forced-white tops) makes detection pages look blank. */
.report_item{
    display: flex;
    flex-direction: column;
    font-size: .8rem;
    color: #222;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 6px;
    margin-bottom: 1rem;
    page-break-inside: avoid;
    break-inside: avoid;
    .report_item_top{
        display: flex;
        background: #fff;
        padding: 1.5rem;
        border-radius: 6px 6px 0 0;
        z-index: 1;
        .report_item_top__title{
            color: #111;
            margin-bottom: 1rem;
        }
    }
    .report_item_bottom{
        font-size: .7rem;
        background: #fff;
        color: #222;
        padding: 1.5rem;
        border-top: 1px solid #ddd;
        border-radius: 0 0 6px 6px;
        /* Expand fully for PDF — fixed height + overflow clips html2canvas */
        height: auto;
        max-height: none;
        overflow: visible;
        .report_item_bottom__video + .report_item_bottom__video{
            margin-top: 1.5rem;
        }
        .report_item_bottom__video{
            .report_item_bottom__video_title{
                display: inline-block;
                background: #eef2f5;
                color: #111;
                border: 1px solid #ccc;
                border-radius: 4px;
                padding: 3px 10px;
                margin-bottom: .75rem;
            }
            .report_item_bottom__video_galleryblock{
                display: flex;
                gap: 15px;
                flex-wrap: wrap;
            }
            .report_item_bottom__video_gallery{
                width: 115px;
                color: #222;
                img{
                    width: 100%;
                    margin-bottom: .5rem;
                    border: 1px solid #ccc;
                    background: #f5f5f5;
                }
            }
        }
    }
    .report_imageblock{
        display: flex;
        gap: 1rem;
        margin-right: 1.5rem;
        width: 280px;
        overflow-x: hidden;
        flex-shrink: 0;
        .report_imageblock__item{
            width: 110px;
            height: 110px;
            min-width: 96px;
            min-height: 96px;
            object-fit: cover;
            background-color: #eee;
            border: 1px solid #ccc;
        }
    }
    .report_center{
        width: 100%;
        .report_center__data{
            display: grid;
            gap: 1rem;
            grid-template-columns: auto auto auto;
        }
    }
}
.report_t_d{
    display: flex;
    margin-bottom: .5rem;
    color: #333;
    span{
        min-width: 42px;
        color: #555;
    }
    .report_t_d__value{
        color: #111;
        font-weight: bold;
        margin-left: .5rem;
    }
}
.spoof-warning{
    color: #8a5a00;
    font-weight: 600;
    span{
        min-width: auto;
        color: #8a5a00;
    }
}
</style>
